module.exports = __webpack_public_path__ + "static/media/Daily Emails for CLIENT FILE.c7fa1930.png";